module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_7042.9ba58ded.png";